import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../brand/Logo";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import { capture, EVENTS } from "../../analytics/posthog";

const LINKS = [
  { href: "/#producto", label: "Producto", id: "producto" },
  { href: "/#como-funciona", label: "Cómo funciona", id: "como-funciona" },
  { href: "/#precios", label: "Precios", id: "precios" },
  { href: "/#faq", label: "FAQ", id: "faq" },
];

export const PublicNav = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="glass fixed top-0 z-50 w-full border-b border-white/10" data-testid="public-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
        <a href="/" data-testid="public-logo-link" className="flex items-center"><Logo /></a>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-400">
          {LINKS.map((l) => (
            <a key={l.id} href={l.href} data-testid={`nav-${l.id}`} className="hover:text-white transition-colors">{l.label}</a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button onClick={() => navigate("/auth")} data-testid="public-login-link" className="text-sm text-slate-300 hover:text-white transition-colors">
            Entrar
          </button>
          <Button data-testid="public-register-button" onClick={() => { capture(EVENTS.signupClicked, { cta: "nav" }); navigate("/auth?mode=register"); }}
            className="bg-amber-500 text-black hover:bg-amber-400 rounded-full font-semibold">
            Crear cuenta
          </Button>
        </div>

        <button className="md:hidden -mr-2.5 inline-flex h-11 w-11 items-center justify-center text-slate-200" onClick={() => setOpen((v) => !v)} data-testid="public-menu-toggle" aria-label="Menú">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 glass px-4 py-5 space-y-4" data-testid="public-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.id} href={l.href} onClick={() => setOpen(false)} data-testid={`nav-mobile-${l.id}`}
              className="block text-sm text-slate-300 hover:text-white">{l.label}</a>
          ))}
          <div className="pt-2 flex flex-col gap-3">
            <button onClick={() => navigate("/auth")} data-testid="public-login-link-mobile" className="text-left text-sm text-slate-300 hover:text-white">Entrar</button>
            <Button onClick={() => { capture(EVENTS.signupClicked, { cta: "nav_mobile" }); navigate("/auth?mode=register"); }} data-testid="public-register-button-mobile"
              className="bg-amber-500 text-black hover:bg-amber-400 rounded-full font-semibold w-full">Crear cuenta</Button>
          </div>
        </div>
      )}
    </header>
  );
};
